import { render, staticRenderFns } from "./SwitchUser.vue?vue&type=template&id=4eeebbaa&"
import script from "./SwitchUser.vue?vue&type=script&lang=js&"
export * from "./SwitchUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports